import Components from "views/Components/Components.jsx";
import ContactPage from "views/ContactPage/ContactPage.jsx";
import AboutUsPage from "views/AboutUsPage/AboutUsPage.jsx";
import ProjectPage from "views/ProjectPage/ProjectPage.jsx";
import CivilPage from "views/CivilPage/CivilPage.jsx";
import ArchiPage from "views/ArchiPage/ArchiPage.jsx";
import ICTPage from "views/ICTPage/ICTPage.jsx";
import MechPage from "views/MechPage/MechPage.jsx";
import OilPage from "views/OilPage/OilPage.jsx";
import PortPage from "views/PortPage/PortPage.jsx";


var indexRoutes = [
  { path: "/contact", name: "ContactPage", component: ContactPage },
  { path: "/about", name: "AboutUsPage", component: AboutUsPage },
  { path: "/projects", name: "ProjectPage", component: ProjectPage },
  { path: "/civil", name: "CivilPage", component: CivilPage },
  { path: "/arch", name: "ArchiPage", component: ArchiPage },
  { path: "/mech", name: "MechPage", component: MechPage },
  { path: "/ict", name: "ICTPage", component: ICTPage },
  { path: "/oil", name: "OilPage", component: OilPage },
  { path: "/port", name: "PortPage", component: PortPage },
  { path: "/", name: "Components", component: Components }
];
export default indexRoutes;


// WEBPACK FOOTER //
// ./src/routes/index.jsx